var React = require('react');

function Switch (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none"},[React.createElement("path",{"d":"m3 28.629 7.408 11.031 8.52-10.202","key":0}),React.createElement("path",{"d":"m63 40.064-7.403-11.037-8.525 10.205","key":1}),React.createElement("path",{"d":"m55.499 29.125c0.898 5.698-0.384 11.524-3.591 16.318-3.208 4.793-8.104 8.201-13.714 9.544-3.727 0.883-7.617 0.805-11.306-0.229-3.688-1.035-7.052-2.99-9.776-5.683","key":2}),React.createElement("path",{"d":"m10.419 39.596c-0.752-3.019-0.899-6.157-0.431-9.232 0.468-3.076 1.541-6.028 3.157-8.686s3.744-4.969 6.259-6.8 5.368-3.145 8.394-3.866c3.978-0.942 8.138-0.787 12.035 0.45s7.385 3.509 10.091 6.573","key":3})]));
}

Switch.defaultProps = {"clipRule":"evenodd","fillRule":"evenodd","strokeLinejoin":"round","strokeMiterlimit":"2","version":"1.1","viewBox":"0 0 66 66","xmlSpace":"preserve"};

module.exports = Switch;

Switch.default = Switch;
